import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

// Models
import { accountStatus, User } from 'src/app/modules/account/models/user';
import { InvoicesData } from 'src/app/modules/invoices/models/invoices';

// Services
import { UiService } from 'src/app/platform/services/ui.service';
import { UserService } from 'src/app/modules/account/user.service';
import { InvoicesService } from 'src/app/modules/invoices/invoices.service';

// Components
import { UiDialogComponent } from 'src/app/platform/components/ui-dialog/ui-dialog.component';
import { PayModalComponent } from 'src/app/modules/payments/components/pay-modal/pay-modal.component';
import { PaymentsReportComponent } from 'src/app/modules/payments/views/payments-report/payments-report.component';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {
  public user: User = new User();
  public invoiceLast: InvoicesData = new InvoicesData();

  constructor(
    private router: Router,
    private uiDialog: MatDialog,
    private uiService: UiService,
    private userService: UserService,
    private paymentReportDialog: MatDialog,
    private invoicesService: InvoicesService,
  ) {
    this.userService.currentUser.subscribe((user) => {
      this.user = user;
    });
  }

  ngOnInit(): void { }

  accountStatus(status: string): string {
    return accountStatus(status);
  }

  onPaymentAll(): void {
    this.uiDialog.open(PayModalComponent, {
      width: '400px',
    });
  }

  onReportPayment(): void {
    this.paymentReportDialog.open(PaymentsReportComponent, {
      width: '400px',
      data: ''
    });
  }

  onDownloadLastInvoice(): void {
    this.uiDialog.open(UiDialogComponent, {
      width: '350px',
      data: {
        title: 'Descarga',
        message: '¿Desea descargar la última factura?',
        buttonCancelText: 'Cancelar',
        buttonConfirmText: 'Descargar',
        action: () => {
          this.uiService.showSpinner(true);

          this.invoicesService.invoicesLastGet().then((invoice) => {
            this.invoicesService.pdfGet(invoice.result.id, invoice.result.type).then((success) => {
              this.uiService.showSpinner(false);
              window.open(success.result.url, '_blank');
            }).catch((error) => {
              this.uiService.showSpinner(false);
              this.uiService.dialogShow('Ups!', 'No es posible generar el PDF de la última factura emitida en este momento. Estamos trabajando para solucionar el inconveniente.', 'alert');
            });
          }).catch(() => {
            this.uiService.showSpinner(false);
            this.uiService.dialogShow('Factura no disponible', 'De momento no es posible cargar la última factura emitida. Consultá esta información más tarde.', 'alert');
          });
        }
      }
    });
  }

  onMyBills(): void {
    this.router.navigate(['facturas']);
  }
}
